<template>
  <v-dialog v-model="modal" scrollable width="80%" height="80%">
    <template v-slot:activator="{ on: onMenu }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: onTip }">
          <v-btn icon v-on="{ ...onTip, ...onMenu }"><v-icon>local_library</v-icon></v-btn>
        </template>
        Import from Library
      </v-tooltip>
    </template>
    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Workspace Library</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="modal = false"><v-icon>close</v-icon></v-btn>
      </v-toolbar>
      <v-card flat style="height: 80vh; overflow-y: hidden;">
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <workspace-resource-list @addToContext="addToContext"></workspace-resource-list>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import WorkspaceResourceList from './WorkspaceResourceList';
import { mapActions, mapGetters } from 'vuex';
export default {
  components: { WorkspaceResourceList },
  data() {
    return {
      modal: false
    };
  },
  computed: {
    ...mapGetters('context', ['context'])
  },
  methods: {
    ...mapActions('resources', ['addResourceToContext']),
    addToContext(resourceId) {
      this.addResourceToContext({ resourceId, context: this.context });
    }
  }
};
</script>
